import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import CollapsibleSection from '@v2/commons/components/ModalCollapsibleSection/ModalCollapsibleSection.component'
import ChatMessages from '@v2/domains/chat/components/chat.component'
import useChatMessages from '@v2/domains/chat/hooks/useChatMessages.hook'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'

const TaskEscalationNotes = ({ chatId }: { chatId: string }) => {
  const {
    messages,
    addChatMessageMutationStatus,
    isGetMessagesError,
    onAddNote,
    onUpdateNote,
    updateChatMessageMutationStatus,
    onDeleteNote,
    deleteChatMessageMutationStatus,
    hasUpdtaeMessagePolicy,
    hasDeleteMessagePolicy,
    currentUserId,
  } = useChatMessages(chatId)
  return (
    <CollapsibleSection header="Additional Notes">
      <ChatMessages
        messages={messages}
        addChatMessageMutationStatus={addChatMessageMutationStatus}
        isGetMessagesError={isGetMessagesError}
        onAddNote={onAddNote}
        onUpdateNote={onUpdateNote}
        updateChatMessageMutationStatus={updateChatMessageMutationStatus}
        onDeleteNote={onDeleteNote}
        deleteChatMessageMutationStatus={deleteChatMessageMutationStatus}
        hasUpdtaeMessagePolicy={hasUpdtaeMessagePolicy}
        hasDeleteMessagePolicy={hasDeleteMessagePolicy}
        currentUserId={currentUserId}
      />
    </CollapsibleSection>
  )
}
export default withErrorBoundaryAndPolicyCheck(
  TaskEscalationNotes,
  WbfPolicies.is_get_chat_messages_enabled,
)
